"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientBase = void 0;
const httpClient_1 = __importDefault(require("./utils/httpClient"));
class ClientBase {
    constructor(baseUrl, env, logger) {
        this.httpClient = (0, httpClient_1.default)(baseUrl);
        this.environment = env;
        this._logger = logger;
    }
    // Method to parse errors to default error format
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    processError(err, message, ...logData) {
        if (err.response) {
            // Request made and server responded
            if (err.response.status === 404) {
                this._logger?.info(`404 response: ${message}`, err, ...logData);
                // Return null on NotFound exception
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return { success: true, data: null };
            }
            const errors = [];
            if (err.response.data?.error?.errors) {
                errors.push(...err.response.data.error.errors);
            }
            else {
                errors.push({
                    title: err.message,
                    type: 'UnhandledException',
                });
            }
            this._logger?.error(`Error from module: ${message}`, err, ...logData);
            return {
                success: false,
                error: {
                    errors,
                    status: err.response.status,
                    stack: err.response.data?.stack,
                },
            };
        }
        let stack;
        if (this.environment !== 'prod' && this.environment !== 'production') {
            stack = err.stack;
        }
        this._logger?.error(`Connectivity problems: ${message}`, err, ...logData);
        // The request was made but no response was received
        return {
            success: false,
            error: {
                errors: [
                    {
                        title: err.message,
                        type: 'UnhandledException',
                    },
                ],
                status: 503,
                stack,
            },
        };
    }
}
exports.ClientBase = ClientBase;
